export default "__VITE_ASSET__DskPL6wF__"